import { styled, css } from '../../style';

const StyledButton = styled('div')(
  ({ theme }) => css`
    background: linear-gradient(90deg, #ffdc22 34.06%, #ffb600 50%);
    padding: 10px;
    text-align: center;
    color: ${theme.black};
    font-size: 20px;
    font-weight: 700;

    @media (max-width: ${theme.mobileWidth}) {
      font-size: 17px;
    }

    .close-icon {
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;
    }
  `
);

export default StyledButton;
